/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UploadContentType = {
    ApplicationPdf: 'application/pdf',
    ImageJpeg: 'image/jpeg',
    ImagePng: 'image/png',
} as const;
export type UploadContentType = typeof UploadContentType[keyof typeof UploadContentType];


export function instanceOfUploadContentType(value: any): boolean {
    for (const key in UploadContentType) {
        if (Object.prototype.hasOwnProperty.call(UploadContentType, key)) {
            if (UploadContentType[key as keyof typeof UploadContentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UploadContentTypeFromJSON(json: any): UploadContentType {
    return UploadContentTypeFromJSONTyped(json, false);
}

export function UploadContentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadContentType {
    return json as UploadContentType;
}

export function UploadContentTypeToJSON(value?: UploadContentType | null): any {
    return value as any;
}

export function UploadContentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): UploadContentType {
    return value as UploadContentType;
}

